module.exports = function smartPromptFunc(app) {
  app.channel.on('render:smart-prompt', async (user) => {
    await import(/* webpackChunkName: "smart-prompt" */ '@feature/smart-prompt/src/smart-prompt');
    const promptChannel = require('backbone.radio').channel('signIn');
    promptChannel.trigger('signInComplete', user);
  });
};
